export interface IUserLoginRequest {
  email: string;
  password: string;
}

export interface IAdminLoginRequest {
  password: string;
}

export interface IORGRegistrationRequest {
  company_name: string;
  company_address: string;
  company_phone: string;
  company_email?: string;
}


export interface IUpdatePrivateAreaPersonal {
type: "personal"
name?: string;
phone?: string;
role?: string;
}

export interface IUpdatePrivateAreaEmail {
type: "email";
email?: string;
updatedEmail?: string;
newEmail?: string;
}



export interface IUpdateLanguage {
  language: string;
}


export interface IOrganizationUpdate {
  id?: any;
  image_url?: string;
  preview?: any;
  company_name?: string;
  company_address?: string;
  isInspectionType?: boolean;
}

export interface IInviteUser {
  email: string;
  authorization: string;
  language?: string;
}

export interface IForgotRequest {
  email: string;
}
export interface IUserLoginResponse {
  token: string;
  refreshToken: string;
  user: User;
}

export interface IProjectListResponse {
  id?: string;
  name?: string;
  client_name?: string;
  index?: number;
  revisions?: any[];
  address?: string;
  type?: string;
  climate?: string;
  city?: string;
  totalRequiredPointsWithTransaction?: number;
  createdBy?: string;
  bg_color?: string;
  image_url?: string;
  updatedAt?: string;
  /** Most advanced inspector status across project revisions, if any */
  inspection?: {
    inspectorStatus?: 'awaiting' | 'pending' | 'reviewed' | 'checked';
    hasInspectorAssignment?: boolean;
  } | null;
  refetch?: any;
  handleDeleteProject?: any;
}

export interface IProjectAddRequest {
  id?: any;
  name?: string;
  client_name?: string;
  type?: string;
  city?: string;
  terrain?: string;
  climate?: string;
  partition?: string;
  construction?: string;
  version?: string;
  gush?: string;
  address?: string;
  bg_color?: string;
  image_url?: string;
  preview?: any;
  organizationId?: any;
  publicId?: any;
  skip_overwrite?: boolean;
  single_block_per_floor?: boolean;
}

export interface IProjectResponseData {
  id: string;
  address: string;
  name: string;
  client_name?: string;
  construction: string;
  bg_color: string;
  city: string;
  climate:  string;
  terrain: string;
  type: string;
  version: string;
  image_url?: string;
  gush: string;
  partition: string;
  createdAt: string;
  updatedAt: string;
  skip_overwrite: boolean;
  single_block_per_floor?: boolean;
  revision?: {
    id: string;
    rating: string;
    weighed_grade: string;
    updatedAt: string;
    status: string;
    requiredPoints: number;
    totalSurface: number;
    notes: string;
  };
}

export interface IRevisionWithProjectResponse {
  revision_id: string;
  revision_status: string;
  revision_createdAt: string;
  revision_updatedAt: string;
  revision_weighed_grade: number;
  revision_rating: string;
  skip_overwrite?: boolean;
  has_mod_idf?: boolean;
  has_idf?: boolean;
  idf_name?: string;
  transaction_id?: string | null;
  startedAt?: string | null;
  mod_idf_download_allowed?: boolean;
  project_id: string;
  project_name: string;
  project_version: string;
  project_climate: string;
  project_construction: string;
  project_terrain: string;
  project_type: string;
  project_createdAt: string;
  project_updatedAt: string;
  organization_id: string;
  organization_name: string;
}

export interface IOrganizationResponse {
  id: string;
  company_name: string;
  updatedAt: string;
  image_url: string;
  company_phone: string;
  company_address: string;
  company_email: string;
  isInspectionType?: boolean;
  members: Member[];
  invites: Invites[];
  transactions?: any;
  hasTrial?: boolean;
  totalCredits?: number;
  totalPoints?: number;
  hasUnlimited?: boolean;
}

export interface Invites {
  id: string;
  email: string;
  invitedByName: string;
  authorization: string;
}

export interface Member {
  id: string;
  email: string;
  name: string;
  updatedAt: string;
  authorization: string;
  status: string;
}

export interface Profile {
  organizations: any;
  user: User;
}

export interface User {
    id?: string
    email?: string
    address?: string
    language?: string
    memberOf?: any[]
    name: string
    role: string
    organizationId?: string
    phone: any
}

export interface Auth {
  exp: any;
  id: string;
  token: string;
}

export interface IAdminTopUp {
  ProdQuantity?: number;
  ProductDesc?: string;
  TotalPoints?: string | undefined;
  OrganizationId?: string;
  TransactionId?: string;
  ProductID?: string;
  suminfull?: string;
}

export interface IErrorResponse {
  ServerErrorCode?: IErrorObject[];
  GeneralErrorCode?: string;
  actualError?: any;
}

export interface IResetPasswordRequest {
    newPassword: string
    confirmPassword:string
    token: string
}

export interface IErrorObject {
  field: string;
  code: string;
}

export interface IUpdatePassword {
  oldPassword: string;
  newPassword: string;
  newPasswordAgain: string;
}

export enum RevisionStatus {
  CHECKED = 'checked',
  FAILED = 'failed',
  VALIDATING = 'validating',
  RESOLVING = 'resolving',
  PROCESSING = 'processing',
  PENDING = 'pending',
  SUCCESS = 'success',
  TICKET_ON_GOING = 'ongoing',
  TICKET_OPEN = 'open',
  INIT = 'init',
}

export interface IRevisionCreate {
  file?: any;
  notes?: string;
  h_report_density?: string;
  h_report_percentage?: number;
  h_report_uvalue?: number;
  simulator?: string;
  skip_overwrite?: boolean;
}

export interface IRevisionEditFile {
  files?: Record<string, FileSchema>;
}

export interface FileSchema {
  name: string;
  url: string;
  publicId: string;
}

export interface ITicketData {
  user?: ITicketUser;
  ticket?: Ticket;
  revision?: Revision;
  project?: ProjectOrOrganization;
  organization?: ProjectOrOrganization;
}
export interface ITicketUser {
  id?: string;
  name?: string;
  email?: string;
  phone?: string | null;
}
export interface Ticket {
  id?: string;
  status?: string;
  updatedAt?: string;
}
export interface Revision {
  id?: string;
  status?: string;
}
export interface ProjectOrOrganization {
  id?: string;
  name?: string;
  image_url?: string
}

export type Order = 'asc' | 'desc';


export interface IPictureData {
  id: string , 
  type: string , 
  file:string , 
  destination: string , 
  size: string
}
